export enum AuthRoutes {
  CheckToken = 'check-token',
  Login = 'login',
  Logout = 'logout',
  RefreshToken = 'refresh-token',
}
